import { InteractionData } from 'src/app/redux/interaction/interaction-slice.type';

export const convertInteractionToEditFormData = (interaction: InteractionData) => {
  return {
    name: interaction.name,
    fromInterestType: interaction.fromInterest.type,
    fromInterestId: interaction.fromInterestId,
    toInterestType: interaction.toInterest.type,
    toInterestId: interaction.toInterestId,
    interactionTypeId: interaction.interactionTypeId,
  };
};
